export class Team {
    Dept;
    TeamCode;
    CDesc;
    EDesc;
    constructor() {
      this.Dept = "";
      this.TeamCode = "";
      this.CDesc = "";
      this.EDesc = "";
    }
  }
  


// WEBPACK FOOTER //
// ./src/model/Team.js